var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-start":"","fill-height":""}},[_c('v-flex',{staticClass:"filter_sizer"},[_c('document-filter',{attrs:{"isLink":false,"newSearch":_vm.$route.params.newSearch}})],1),_c('v-flex',{staticClass:"document_sizer"},[_c('document-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }